import * as React from "react";
import Box from "@mui/material/Box";
import {Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import BlogsCard from "./ProjectsCard";

const AllProjects = () => {
    const [allProjectslists, setAllProjectslists] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    React.useEffect(() => {
      fetch("./allprojects.json")
        .then((response) => response.json())
        .then((data) => {
          setAllProjectslists(data);
          setIsLoading(false);
        });
    }, []);
  return (
<Box>
<Container sx={{ border: 0 }} maxWidth="lg">
<Typography variant="h4" gutterBottom component="div" sx={{textAlign: "center", my: 4 }}>
        ALL PROJECTS
      </Typography>
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {allProjectslists.map((allProjectslist, index) => (
            <BlogsCard isLoading={isLoading} projects={allProjectslist} key={allProjectslist?.id}></BlogsCard>
          ))}
        </Grid>
      </Box>
    </Container>
</Box>
  );
};

export default AllProjects;
